<template>
  <div> 
    <v-col xs="12" px="4" pt="2" my="3">
      <h2 class="headline">Connect your Dataset</h2>
      <div>For application developers, Himydata offers a way to connect your data easily, all available via the Data API.</div>
    </v-col>
    <v-row>
      <v-col xs="12" sm="2" md="2" lg="2" class="pl-10 pr-5">
        <div style="height: 40px;" class="hidden-xs-and-down" ></div>
        <h3 class="grey--text"><v-icon color="grey" class="mr-1">mdi-chevron-right</v-icon>Actions</h3>
        <template v-for="(key, index) in tabs.actions">
          <v-btn
            :outlined="(currentAction === key)"
            large
            block
            @click.native="changeAction(key, index)" :key="key"
            class="mb-1"
          >{{key}}</v-btn>
        </template>
      </v-col>
      <v-col md="10">
        <v-tabs
          v-model="active"
          class="tabs-style-iconfall"
          icons-and-text
          slider-color="primary"
        >
          <v-tab
            v-for="(api, index) in tabs.languages"
            :key="api.lang"
            ripple
            @click="handleTabChange(api, index)"
            class="ml-0"
          >
            {{ api.language }}
            <img :src="api.icon" :alt="api.language">
          </v-tab>
          <v-tab-item
            v-for="(api, index) in tabs.languages"
            :key="index"
          >
            <v-card flat>
              <v-col cols="12" class="grey lighten-4 pa-0 text-right">
                <v-btn
                  text
                  small
                  color="primary"
                  v-clipboard:copy="codeToCopyProp"
                >
                  <v-icon small left class="mr-1">mdi-content-copy</v-icon>Copy
                </v-btn>
              </v-col>
              <editor
                id="editor"
                @init="editorInit"
                :value="codeToCopyProp"
                :lang="api.lang"
                theme="chrome"
                width="100%"
                height="420px"
                :options="options"
              ></editor>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-col>
    </v-row>
  </div>
</template>

<script>

  export default {
    components: {
      editor: require('vue2-ace-editor'),
    },
    data: function() {
      return {
        active: 0,
        options: {
          fontSize: '22',
          readOnly: true,
          highlightActiveLine: false,
          highlightGutterLine: false
        },
      }
    }, 
    props: {
      dataset: {
        type: Object,
        default: () => {
          return {
            name: '',
            description: '',
            updated_at: '',
            type: ''
          }
        }
      },
      tabs: Object,
      codeToCopyProp: String,
      currentLanguageProp: String,
      currentActionProp: String,
    },
    computed: {
      currentAction: function(){
        return this.currentActionProp
      },
      currentLanguage: function(){
        return this.currentLanguageProp
      },
    },
    watch: {
      codeToCopyProp: function(){
        // TODO: find how to resize editor to make sure the content in updated
        // if we don't do this there is a bug where content is most of the time not 
        // updated in the editor but it is updated in the copy to clipboard button for example.
        // you can reproduce this by selecting a language then switching action and then
        // switch language. The content will be updated once you click on the editor.
        // editor.resize()
      },
    },
    methods: {
      editorInit: function () {
        require('brace/mode/python')
        require('brace/mode/sh')
        require('brace/mode/php')
        require('brace/mode/java')
        require('brace/mode/ruby')
        require('brace/mode/javascript')
        require('brace/theme/chrome')
      },
      changeAction(key, index) {
        this.$emit('changeAction', key)
      },
      handleTabChange(api, tabIndex){
        this.$emit('changeLanguage', api.language)
      },
    },
  }
</script>